import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {catchError, switchMap} from 'rxjs/operators';
import {from, of} from 'rxjs';
import {LoadError} from '@app/core/store/actions/error.actions';
import {DayNotePopupComponent} from '@app/core/popups/day-note-popup/day-note-popup.component';
import {DayNote} from '@app/core/models/day-note.model';
import {DayNoteService} from '@app/core/services/api/day-note.service';
import {
	DeleteDayNote,
	DeleteDayNoteSuccess,
	EDayNotesActions,
	GetDayNotes,
	GetDayNotesSuccess,
	PatchDayNote,
	PatchDayNoteSuccess,
	PostDayNote,
	PostDayNoteSuccess,
	SetSelectedDate,
	SetSelectedDayNote
} from '@app/core/store/actions/daynotes.actions';
import {MatDialog} from '@angular/material/dialog';
import {DayNotesPopupComponent} from '@app/core/popups/day-notes-popup/day-notes-popup.component';

@Injectable()
export class DayNotesEffects {

	@Effect()
	public onSetSelectedDayNote$ = this.actions$.pipe(
		ofType<SetSelectedDayNote>(EDayNotesActions.SetSelectedDayNote),
		switchMap((action: SetSelectedDayNote) => {
			if (action.dayNote !== undefined) {
				this.dialog.open(DayNotePopupComponent, {
					restoreFocus: false,
				});
			}
			return [
				new SetSelectedDate(action.selectedDate, true)
			];
		}),
	);
	@Effect()
	public onSetSelectedDate$ = this.actions$.pipe(
		ofType<SetSelectedDate>(EDayNotesActions.SetSelectedDate),
		switchMap((action: SetSelectedDate) => {
			if (action.disablePopup === false) {
				this.dialog.open(DayNotesPopupComponent, {
					restoreFocus: false,
				});
			}
			return [];
		}),
	);
	@Effect()
	public onPatchDayNote$ = this.actions$.pipe(
		ofType<PatchDayNote>(EDayNotesActions.PatchDayNote),
		switchMap((action: PatchDayNote) => from(this.dayNoteService.patch(action.dayNoteId, action.data)).pipe(
			switchMap((dayNote: DayNote) => {
					return [
						new PatchDayNoteSuccess(dayNote)
					];
				}
			),
			catchError(error => of(new LoadError(error, action))),
		)),
	);
	@Effect()
	public onPostDayNote$ = this.actions$.pipe(
		ofType<PostDayNote>(EDayNotesActions.PostDayNote),
		switchMap((action: PostDayNote) => from(this.dayNoteService.post(action.data)).pipe(
			switchMap((dayNote: DayNote) => {
					return [
						new PostDayNoteSuccess(dayNote)
					];
				}
			),
			catchError(error => of(new LoadError(error, action))),
		)),
	);
	@Effect()
	public onDeleteDayNote$ = this.actions$.pipe(
		ofType<DeleteDayNote>(EDayNotesActions.DeleteDayNote),
		switchMap((action: DeleteDayNote) => from(this.dayNoteService.delete(action.dayNoteId)).pipe(
			switchMap(() => {
					return [
						new DeleteDayNoteSuccess(action.dayNoteId)
					];
				}
			),
			catchError(error => of(new LoadError(error, action))),
		)),
	);
	@Effect()
	public onGetDayNotes$ = this.actions$.pipe(
		ofType<GetDayNotes>(EDayNotesActions.GetDayNotes),
		switchMap((action: GetDayNotes) => from(this.dayNoteService.getDayNotes(action.startDate, action.endDate)).pipe(
			switchMap((dayNotes: DayNote[]) => {
					return [
						new GetDayNotesSuccess(dayNotes)
					];
				}
			),
			catchError(error => of(new LoadError(error, action))),
		)),
	);

	constructor(
		private actions$: Actions,
		private dayNoteService: DayNoteService,
		private dialog: MatDialog
	) {
	}
}
